export default __webpack_public_path__ + "static/media/converter.dbd6aa23.png";